import React from "react";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";

function TodosError({ searchValue, setSearchValue }) {
  return (
    <p className="text-center mt-3">
      <ExclamationTriangleIcon className="h-6 w-6 mx-auto" aria-hidden="true" />
      ¡Error!
    </p>
  );
}

export { TodosError };
